import { Helmet } from "react-helmet-async";
import { localBusinessSchema } from "@/lib/businessSchema";
import { useLocation } from "react-router-dom";

export function LocalBusinessSchema() {
  const { pathname } = useLocation();
  const { openingHoursSpecification, ...businessWithoutHours } = localBusinessSchema;
  const schema = pathname === "/gilbert-tile-grout-restoration" ? businessWithoutHours : localBusinessSchema;
  return <Helmet><script id="site-local-business-schema" type="application/ld+json">{JSON.stringify(schema)}</script></Helmet>;
}